// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color--primary[data-v-13f8e8c3]{color:#0c83d3}@media only screen and (max-width: 768px){.agent--container[data-v-13f8e8c3]{padding:0 4px}}", ""]);
// Exports
module.exports = exports;
